import React from 'react';
import { CommonLoading } from 'react-loadingg';
import './loading.scss'

export const Loading = () => {
    return <CommonLoading />;
};

export default Loading;
